import useClassName from './use-class-name';

export interface CardProps {
  children: React.ReactNode;
  onClick?: VoidFunction;
  elevation?: 0 | 1 | 2;
}

export const Card = ({ children, elevation = 0, onClick }: CardProps) => {
  const classNames = useClassName({ elevation, clickable: Boolean(onClick) });

  return (
    <div onClick={onClick} className={classNames}>
      {children}
    </div>
  );
};
